import { CreditNote } from 'entities/CreditNote';
import { CreditNoteItem, PaymentCreditNoteType } from 'entities/CreditNote/model/types';
import { DepositRefundNote } from 'entities/Deposit';
import { DocumentType, Invoice, InvoiceItem, InvoiceItemType } from 'entities/Invoice';
import { User } from 'entities/User';

export enum PaymentProcessor {
  STRIPE = 'stripe',
  PAYPAL = 'payPal',
  AUTOPAY = 'autopay',
  SEPA = 'sepa_debit',
  BANK_TRANSFER = 'bank_transfer',
  OTHER = 'other', // Duplicate of bank transfer
  CASH = 'cash',
}

export enum PaymentMethod {
  ONLINE_PAYMENT = 'online_payment',
  BANK_TRANSFER = 'bank_transfer',
  USER_BALANCE = 'user_balance',
  OTHER = 'other',
  CASH = 'cash',
  TERMINAL_PAYMENT = 'terminal_payment',
  // STRIPE_AUTO = 'stripe_auto',
}

export enum RefundMethod {
  USER_BALANCE = 'user_balance',
  WRITE_OFF_LIABILITY = 'write-off of a liability',
}

export enum PaymentStatus {
  COMPLETED = 'Completed',
  REFUND_IN_PROGRESS = 'Refund in progress',
  REFUNDED = 'Refunded',
  REFUND_ERROR = 'Refund error',
}

export interface Refund {
  refundId: string;
  paymentMethod: PaymentProcessor;
  transactionId: string;
  currency: string;
  amount: number;
  documentNumber: string;
  documentType: DocumentType;
  refundItems: RefundItem[];
  description?: string;
  createdAt: string;
  payment: Payment;
}

export interface RefundItem {
  refundItemId: string;
  refund?: Refund;
  refundItemType: InvoiceItemType;
  vatRatePercent: number;
  vatRateAmount: number;
  amount: number;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export interface Payment {
  paymentId: string;
  user: User;
  paymentMethod: PaymentProcessor;
  transactionId: string;
  currency: string;
  documentNumber: string;
  documentType: DocumentType;
  invoice: Invoice;
  amount: number;
  vatRatePercent: number;
  vatRateAmount: number;
  maxRefundAmount: Nullable<number>;
  description?: string;
  creditNote?: CreditNote;
  paymentItems: PaymentItem[];
  refund?: Refund;
  depositRefundNote?: DepositRefundNote;
  paymentStatus: PaymentStatus;
  refundedBy: Nullable<User>;
  markedAsPaidBy: Nullable<User>;
  createdAt: string;
}

export interface PaymentItem {
  paymentItemId: string;
  payment: Payment;
  invoiceItemId?: string;
  invoiceItem?: InvoiceItem;
  creditNoteItem?: CreditNoteItem;
  paymentItemType: InvoiceItemType;
  vatRatePercent: number;
  vatRateAmount: number;
  maxRefundAmount: Nullable<number>;
  amount: number;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export interface PaymentParams {
  paymentId: string;
  description?: Nullable<string>;
}

export interface RefundItemDTO {
  paymentItemId: string;
  amount: number;
}

export interface MarkAsRefundedPaymentParams extends PaymentParams {
  paymentMethod: string;
  refundItems: RefundItemDTO[];
  isDepositRefund?: boolean;
}

export interface CreditAndRefundPaymentParams extends MarkAsRefundedPaymentParams {}

export interface CreditPaymentParams extends PaymentParams {
  creditNoteType: PaymentCreditNoteType;
}

export interface PaymentResponse {
  redirectionUrl: string;
  paymentData?: CustomAny;
}

export interface PaymentMethodSetting {
  name: PaymentMethod;
  isAutoPaymentAllowed: boolean;
  imageUrl?: string;
}
